"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolPerpetualUSDTComponent = void 0;
const FutureAPI_1 = require("../../apis/FutureAPI");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
// 内存缓存 map
const SymbolMap = new Map();
// 内存缓存 array
let SymbolArr = new Array();
/**
 * 手动交易计算最小投资需额外注意. 限价单拿limit中的amount和cost相互换算取最大值. 市价单用dumping代表base量的限制和cost相互换算取最大值
 */
const queryFutureSymbols = () => {
    return (0, FutureAPI_1.getFutureMarkets)().pipe((0, operators_1.map)((value) => {
        const symbols = value.map((e) => {
            const baseStrArr = e.base.split(".");
            const baseDisplay = baseStrArr.length ? baseStrArr[0] : "";
            const item = {
                symbol: e.symbol,
                base: e.base,
                quote: e.quote,
                baseDisplay: baseDisplay,
                quoteDisplay: e.quote,
                isLeverage: false,
                precision: e.quote_precision,
                amount: e.base_precision,
                isSpot: false,
                limit: {
                    amount: {
                        min: e.min_qty_limit ? Number(e.min_qty_limit) : null,
                        max: e.max_qty_limit ? Number(e.max_qty_limit) : null,
                    },
                    cost: { min: e.min_notional ? Number(e.min_notional) : null, max: null },
                    price: { min: null, max: null },
                    spending: { min: null, max: null },
                    dumping: {
                        min: e.min_qty_market ? Number(e.min_qty_market) : null,
                        max: e.max_qty_market ? Number(e.max_qty_market) : null,
                    },
                },
                symbolType: trade_utils_lib_1.ExchangeSymbolType.future_perpetual,
                originData: e,
            };
            // 赋值缓存map
            SymbolMap.set(item.symbol, item);
            return item;
        });
        // 赋值缓存arr
        SymbolArr = symbols;
        return {
            symbols: symbols,
            symbolMap: SymbolMap,
        };
    }));
};
class SymbolPerpetualUSDTComponent {
    static updateMemoryCache(arr) {
        SymbolArr = arr;
        arr.forEach((e) => SymbolMap.set(e.symbol, e));
    }
    static getExchangeSymbol(symbol) {
        return SymbolMap.get(symbol);
    }
    static getExchangeSymbols(forceUpdate = false) {
        if (forceUpdate) {
            return queryFutureSymbols();
        }
        else {
            return (0, rxjs_1.of)({ symbols: SymbolArr, symbolMap: SymbolMap });
        }
    }
}
exports.SymbolPerpetualUSDTComponent = SymbolPerpetualUSDTComponent;
